module.exports = new __parcel__URL__("sheepFight.f1a55b8c.png").toString();